import { Backdrop, Box, Grid, Card, CardContent } from '@mui/material'
import React, { forwardRef, useEffect, useImperativeHandle } from 'react'
import { useState } from 'react';
import { branchName } from '../../../../services/ApiService'
import LoadingSpinner from '../../../../components/Components/LoadingSpinner'
import ButtonBalanceSheetByBranch from './Buttons/ButtonBalanceSheetByBranch'
import ModalConfirmation from '../../../../components/Modals/ModalConfirmation'
import HeaderInfo from '../../../../components/Components/HeaderInfo'
import CustomToastContainer, { CustomDatePicker, Input } from '../../../../components/ui'
import { PrintExcel, PrintPDF } from '../../../../utils/reusableFunction';

const BalanceSheet = forwardRef((props, ref) => {
    const [period, setPeriod] = useState(new Date());
    const [isLoadingPrint, setIsLoadingPrint] = useState(false);
    const labelPeriod = "Period";

    const [isModalConfirmation, setIsModalConfirmation] = useState(false);
    const [titleModalConfirmation, setTitleModalConfirmation] = useState('');
    const [titleConfirmation, setTitleConfirmation] = useState('');

    const BreadcrumbsItems = [
        { label: 'Majura', link: '/Majura', style: '' },
        { label: 'Balance Sheet (Branch) Report', link: '/Majura/BalanceSheetReport', style: { color: '#0087C2', fontWeight: '700' } },
    ];

    useImperativeHandle(ref, () => ({
        localSave() {
            initializeView();
        }
    }));

    useEffect(() => {
        document.title = 'Balance Sheet by Branch Report - ' + JSON.parse(localStorage.getItem('branchName'));
        initializeView();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function initializeView() {
        setIsLoadingPrint(true);
        getDefaultMonth();
        setTimeout(function () { setIsLoadingPrint(false); }, 2000);
    }

    const getDefaultMonth = () => {
        const date = new Date();
        const year = date.getFullYear()
        let month = date.getMonth() + 1

        if (month < 10) {
            month = `0${month}`
        }

        setPeriod(`${year}-${month}`);
    }

    const handleClickConfirmation = () => {
        if (isModalConfirmation === false) {
            setIsModalConfirmation(true);
        }
        else {
            setIsModalConfirmation(false);
        }
    }

    function ConfirmationDRC() {
        if (titleConfirmation === 'Print PDF') {
            PrintReport("pdf", false);
        }
        else if (titleConfirmation === 'Print PDF Explanation') {
            PrintReport("pdf", true);
        }
        else if (titleConfirmation === 'Print Excel') {
            PrintReport("xls", false)
        }
        else if (titleConfirmation === 'Print Excel Explanation') {
            PrintReport("xls", true)
        }
        setIsModalConfirmation(false);
    }

    const PrintData = () => {
        setTitleConfirmation('Print PDF')
        setTitleModalConfirmation('Balance Sheet by Branch Report');
        handleClickConfirmation();
    };

    const PrintDataExplanation = () => {
        setTitleConfirmation('Print PDF Explanation')
        setTitleModalConfirmation('Balance Sheet by Branch Report');
        handleClickConfirmation();
    };

    const PrintExcelData = () => {
        setTitleConfirmation('Print Excel')
        setTitleModalConfirmation('Balance Sheet by Branch Report');
        handleClickConfirmation();
    };

    const PrintExcelExplanation = () => {
        setTitleConfirmation('Print Excel Explanation')
        setTitleModalConfirmation('Balance Sheet by Branch Report');
        handleClickConfirmation();
    };

    const PrintReport = (type, code) => {
        setIsLoadingPrint(true);
        const bln = new Date(period).getMonth();
        const month = bln + 1;
        const year = new Date(period).getFullYear();
        const params = [
            {
                "attr": "period",
                "value": '' + month
            },
            {
                "attr": "yearPeriod",
                "value": '' + year
            },
            {
                "attr": "isExplanation",
                "value": code
            }
        ]
        
        let reportLink = 'Reports/Finance/Print/FinanceReport/BalanceSheetBranchReport/BalanceSheetBranchReport/PrintBalanceSheetBranch?typeReport=' + type;
        if (type === 'pdf') {
            PrintPDF(setIsLoadingPrint, 'Balance Sheet (Branch)', reportLink, params);
        }
        else {
            PrintExcel(setIsLoadingPrint, 'Balance Sheet (Branch)', reportLink, params);
        }
    };

    const ButtonComponents = () => {
        return (
            <ButtonBalanceSheetByBranch
                cetak={PrintData}
                excel={PrintExcelData}
                cetak2={PrintDataExplanation}
                excel2={PrintExcelExplanation}
            />
        )
    }

    return (
        <Box className='w-100' sx={{ width: '100%', p: 3 }}>
            <CustomToastContainer />
            <Grid container spacing={0} direction="column">
                <HeaderInfo
                    title={'Balance Sheet (Branch) Report'}
                    isJobType={false}
                    BreadcrumbsItems={BreadcrumbsItems}
                    ButtonComponents={ButtonComponents}
                />

                <Grid item xs={12} style={{ 'width': '100%', 'borderRadius': '5px' }}>
                    <div style={{ marginTop: '24px' }}>
                        <Grid
                            container
                            spacing={'32px'}
                        >
                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <Card component="div" style={{ borderRadius: '12px', backgroundColor: '#F2F2F2', padding: '16px 24px' }}>
                                    <CardContent>
                                        <Input
                                            label="Branch"
                                            variant="standard"
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            value={branchName || ''}
                                            type='text'
                                            formControlProps={{
                                                sx: {
                                                    width: '100%',
                                                }
                                            }}
                                            disabled
                                        />

                                        <div style={{ marginTop: '16px' }}>
                                            <CustomDatePicker
                                                label={labelPeriod}
                                                name="period"
                                                value={period}
                                                onChange={(e) => { setPeriod(e) }}
                                                type={'month'}
                                                formControlProps={{
                                                    sx: {
                                                        width: '100%',
                                                    }
                                                }}
                                            />
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

            {
                isModalConfirmation && (
                    <ModalConfirmation
                        isModal={isModalConfirmation}
                        titleModal={titleModalConfirmation}
                        title={titleConfirmation}
                        handleClick={handleClickConfirmation}
                        ConfirmationData={ConfirmationDRC}
                    />
                )
            }

            {
                isLoadingPrint && (
                    <Backdrop
                        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={isLoadingPrint}
                    >
                        <LoadingSpinner />
                    </Backdrop>
                )
            }
        </Box>
    )
})

export default BalanceSheet